import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ReduxStoreState } from "web/redux/store";
import { FilterOptionSerializer } from "web/types/serializers";

type UseActiveFiltersResult = {
    filters: FilterOptionSerializer[] | undefined;
    count?: number;
    isActive(option: Pick<FilterOptionSerializer, "id">): boolean;
    isActivePriceMin?: boolean;
    isActivePriceMax?: boolean;
};

export function useActiveFilters(sectionId?: string): UseActiveFiltersResult {
    let filters = useSelector((state: ReduxStoreState) => state.filters.ui.activeFilters);

    const isActive = useMemo(
        () => (option: Pick<FilterOptionSerializer, "id">) => {
            return !!filters?.some((filter) => filter.id === option.id);
        },
        [filters]
    );

    const isActivePriceMin = filters?.some((filter) => filter.id === "final_price_from");
    const isActivePriceMax = filters?.some((filter) => filter.id === "final_price_to");

    if (sectionId) {
        filters = filters?.filter((filter) => filter.section_id === sectionId);
    }

    return {
        filters,
        isActive,
        count: filters?.length,
        isActivePriceMin,
        isActivePriceMax,
    };
}
